import { providers } from '../../providers';
import { youchuan } from '../youchuan';
import type { VideoModelEntry } from '../types';

// 价格表: 人民币/秒
const MIDJOURNEY_I2V = { '480p': 0.12, '720p': 0.36 };
// 查找价格函数
const lookup = (table: Record<string, number>, quality?: string) =>
    table[quality ?? ''] ?? Math.max(...Object.values(table));
// 美元汇率
const RMB_TO_USD = 1 / 6.8;
// rmb to usd 转换
const usd = (rmb: number) => rmb * RMB_TO_USD;

const COST_FACTOR = 1.5;


export const midjourneyModels: VideoModelEntry[] = [
    {
        id: 'midjourney_i2v',
        chef: providers['midjourney'],
        providers: [
            {
                ...providers.midjourney,
                model: youchuan('youchuan-video'),
                getCost: ({ duration, quality }) => {
                    return usd(duration * lookup(MIDJOURNEY_I2V, quality) * COST_FACTOR);
                },
                getPassCount: ({ duration, quality }) => {
                    return usd(duration * lookup(MIDJOURNEY_I2V, quality)) * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            first: {
                aspectRatios: [],
                durations: [5],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: [],
                durations: [5],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
        },
        supportsEdit: false,
        supportsInput: ['first', 'first_last'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];